export type CheckInNameFormat = "firstLast" | "lastFirst";

export type CheckInViewSettings = {
  nameFormat: CheckInNameFormat;
  showIconCheckedIn: boolean;
  showIconLocked: boolean;
  showIconBirthday: boolean;
  showIconOverdue: boolean;
};

export const defaultCheckInViewSettings: CheckInViewSettings = {
  nameFormat: "firstLast",
  showIconCheckedIn: true,
  showIconLocked: true,
  showIconBirthday: true,
  showIconOverdue: true
};



